import { EyeInvisibleOutlined } from '@ant-design/icons'
import { Card, Flex, Tag } from 'antd'
import { Venue as VenueModel } from '../../models/Venue'
import { VenuesCollection } from '../../models/VenuesCollection'
import { DndGrid } from '../../pages/venues/detail/tabs/DndGrid'
import { useAppSelector } from '../../store/hooks'
import { selectVenuesByIds } from '../../store/VenueReducer'
import { Venue } from '../venue/Venue'

interface Props {
  item: VenuesCollection
  onUpdate: (data: any) => void
}

const VenuesCollectionCollection = ({ item, onUpdate }: Props) => {
  const venues = useAppSelector(selectVenuesByIds(item.venues))
  return (
    <DndGrid<VenueModel>
      items={venues}
      styles={{
        idle: { cursor: 'move' },
        dragging: { opacity: 0.4 },
        over: { borderLeft: 0.4 },
      }}
      onItemsChange={(updatedVenues) => onUpdate(updatedVenues)}
      renderItem={(item, style, ref) => (
        <Card ref={ref}>
          <Flex align="center" gap={16}>
            {item.visibility.application === 'hidden' && (
              <Tag color="orange" icon={<EyeInvisibleOutlined />}>
                Hidden
              </Tag>
            )}
            <Flex
              style={{
                opacity: item.visibility.application === 'hidden' ? 0.5 : 1,
              }}
            >
              <Venue.Avatar linkToDetails="name" model={item} />
            </Flex>
          </Flex>
        </Card>
      )}
    />
  )
}

type VenueCollectionCollectionType = {
  Collection: typeof VenuesCollectionCollection
}

export { VenuesCollectionCollection, type VenueCollectionCollectionType }
